import React from 'react';
import { useNavigate } from 'react-router-dom';

function PlanBanner({ planInfo }) {
  const navigate = useNavigate();

  if (!planInfo || planInfo.estado === 'suspendido') return null;

  const { plan_tipo, comunidades_usadas, max_comunidades, trial_expira } = planInfo;
  if (max_comunidades === null) return null; // enterprise: sin límite

  const porcentaje = max_comunidades > 0 ? (comunidades_usadas / max_comunidades) * 100 : 0;
  if (porcentaje < 80) return null; // solo mostrar al 80% o más

  const diasRestantes = trial_expira
    ? Math.ceil((new Date(trial_expira) - new Date()) / (1000 * 60 * 60 * 24))
    : null;

  const esDemo = plan_tipo === 'demo';
  const al100 = comunidades_usadas >= max_comunidades;

  const bgColor = al100 ? '#fef2f2' : '#fffbeb';
  const borderColor = al100 ? '#fca5a5' : '#fcd34d';
  const textColor = al100 ? '#991b1b' : '#92400e';
  const linkColor = al100 ? '#dc2626' : '#d97706';

  return (
    <div style={{
      backgroundColor: bgColor,
      borderBottom: `1px solid ${borderColor}`,
      color: textColor,
      padding: '2px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: '11px',
      gap: '12px',
      lineHeight: '1.4',
    }}>
      <span>
        {al100
          ? `Límite alcanzado: ${comunidades_usadas}/${max_comunidades} comunidades en plan ${plan_tipo}.`
          : `${comunidades_usadas}/${max_comunidades} comunidades usadas.`}
        {esDemo && diasRestantes !== null && diasRestantes > 0 && (
          <> Demo expira en <strong>{diasRestantes}d</strong>.</>
        )}
      </span>
      <button
        onClick={() => navigate('/planes')}
        style={{
          background: 'none',
          border: 'none',
          color: linkColor,
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: 600,
          padding: '0',
          textDecoration: 'underline',
          whiteSpace: 'nowrap',
        }}
      >
        Ver planes →
      </button>
    </div>
  );
}

export default PlanBanner;
